import { cn } from "@/lib/utils"
import { Loader2 } from "lucide-react"

interface AudioLoaderProps {
  isEnglish: boolean
}

export default function AudioLoader({ isEnglish }: AudioLoaderProps) {
  return (
    <div
      className={cn(
        "mt-2 flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-medium",
        isEnglish
          ? "bg-blue-400/20 text-blue-100"
          : "bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-400",
      )}
    >
      <Loader2 className="size-3 animate-spin" />
      <span className="animate-pulse">Generating audio...</span>
    </div>
  )
}
